export const cabecalhos = [

];

export const colunas_ordenacao = [
    {
      descricao: 'Segmento',
      campo: 'segmento'
    },
    {
      descricao: 'Fornecedor',
      campo: 'nome_fornecedor'
    },
    {
      descricao: 'Cod. Interno',
      campo: 'id_produto'
    },
    {
      descricao: 'Cod. Fornecedor',
      campo: 'cod_produto'
    },
    {
      descricao: 'Número Original',
      campo: 'numero_original'
    },
    {
      descricao: 'Nome do Produto',
      campo: 'nome_produto'
    },
    {
      descricao: 'Necessidade DRP',
      campo: 'existe_necessidade_drp'
    },
    {
      descricao: 'Última Venda',
      campo: 'data_ultima_venda'
    },
    {
      descricao: 'Última Compra',
      campo: 'data_ultima_compra'
    },
    {
      descricao: 'Preço de Custo',
      campo: 'preco_custo'
    },
    {
      descricao: 'Preço de Venda',
      campo: 'preco_venda'
    },
    {
      descricao: 'Nível de Importância',
      campo: 'nivel_servico'
    },
    {
      descricao: 'Nível de Estoque',
      campo: 'nivel_estoque'
    },
    {
      descricao: 'ID Pedido Trânsito',
      campo: 'lista_pedidos_em_aberto'
    }
];